import { useEffect } from 'react';
import { useApp } from '../store';
import { Modal } from './Modal';

/** Apstiprinājuma logs (aizstāj window.confirm). */
export function ConfirmDialog() {
  const c = useApp((s) => s.confirm);
  if (!c) return null;
  return (
    <Modal onClose={() => c.resolve(false)} label={c.title} testId="confirm">
      <form
        method="dialog"
        className="dlg"
        onSubmit={(e) => {
          e.preventDefault();
          c.resolve(true);
        }}
      >
        <h3>{c.title}</h3>
        {c.message ? <div className="confirm-msg">{c.message}</div> : null}
        <div className="dlg-actions">
          <span className="sp" />
          <button type="button" className="btn sm" onClick={() => c.resolve(false)}>
            Atcelt
          </button>
          <button type="submit" className={'btn sm ' + (c.danger ? 'danger-fill' : 'primary')} autoFocus>
            {c.ok || 'Labi'}
          </button>
        </div>
      </form>
    </Modal>
  );
}

export function ToastHost() {
  const t = useApp((s) => s.toast);
  const hide = useApp((s) => s.hideToast);
  const undo = useApp((s) => s.undoEntry);
  useEffect(() => {
    if (!t) return;
    const h = setTimeout(hide, t.err ? 10000 : 8000);
    return () => clearTimeout(h);
  }, [t, hide]);
  return (
    <div className={'toast' + (t ? ' on' : '') + (t?.err ? ' err' : '')} role="status" aria-live="polite" data-testid="toast">
      <span>{t?.msg}</span>
      {t?.undoId ? (
        <button
          type="button"
          onClick={() => {
            const id = t.undoId!;
            hide();
            void undo(id);
          }}
        >
          Atsaukt
        </button>
      ) : null}
      {t?.err ? (
        <button type="button" onClick={hide} aria-label="Aizvērt">
          ×
        </button>
      ) : null}
    </div>
  );
}
